export const FETCH_CONVERSION_RATES_START = 'FETCH_CONVERSION_RATES_START'
export const FETCH_CONVERSION_RATES_SUCCESS = 'FETCH_CONVERSION_RATES_SUCCESS'
